import { derived } from "svelte/store";
import { session } from "./session";

export default derived(session, ($session) => $session.profile);
